/* eslint-disable camelcase */
import Api from '../api';

export interface CreateTaskPayload {
  title: string;
  description?: string;
  deadline?: string;
  expected_conclusion_at?: string;
  responsible_id?: number;
  checklist?: string[];
  annotation?: string;
}

export const createBiddingTask = (biddingId: number, payload: CreateTaskPayload) =>
  Api.post(`/gestao_ia/licitacoes/${biddingId}/tarefas`, payload);

export const createBiddingTasksBatch = (biddingId: number, tasks: CreateTaskPayload[]) =>
  Api.post(`/gestao_ia/licitacoes/${biddingId}/tarefas/lote`, { tarefas: tasks });

export interface RecommendedTask {
  title: string;
  start_on: string;
  deadline_on: string | null;
  deadline_time: string | null;
}

export interface RecommendedTasks {
  bidding_id: string;
  data_sessao_publica: string;
  horario_sessao_publica: string;
  exigencia_amostra: string;
  garantia_proposta: boolean;
  data_consulta: string;
  tarefas: RecommendedTask[];
}

export const listRecommendedTasks = (biddingId: number) =>
  Api.get(`/gestao_ia/licitacoes/${biddingId}/tarefas/recomendadas`);

export interface UpdateTaskPayload {
  title?: string;
  description?: string | null;
  deadline?: string | null;
  expected_conclusion_at?: string | null;
  responsible_id?: number | null;
  task_column_id?: number;
}

export const updateTask = (id: number, payload: UpdateTaskPayload) =>
  Api.patch(`/gestao_ia/tarefas/${id}`, payload);

export const deleteTask = (id: number) => Api.delete(`/gestao_ia/tarefas/${id}`);

export const addChecklistItem = (taskId: number, content: string) =>
  Api.post(`/gestao_ia/tarefas/${taskId}/checklist`, { content });

export const updateChecklistItem = (
  taskId: number,
  itemId: number,
  payload: { done?: boolean; content?: string },
) => Api.patch(`/gestao_ia/tarefas/${taskId}/checklist/${itemId}`, payload);

export const deleteChecklistItem = (taskId: number, itemId: number) =>
  Api.delete(`/gestao_ia/tarefas/${taskId}/checklist/${itemId}`);

export const addTaskComment = (taskId: number, text: string) =>
  Api.post(`/gestao_ia/tarefas/${taskId}/anotacoes`, { text });

export const deleteTaskComment = (taskId: number, commentId: number) =>
  Api.delete(`/gestao_ia/tarefas/${taskId}/anotacoes/${commentId}`);
